/**
 * Threshold for hiding additional suggestions behind a show more button.
 * @internal
 */
export const DEFAULT_SUGGESTIONS_COUNT = {
  empty: 5,
  filled: 10,
};
